module.exports = __webpack_public_path__ + "static/svip.3a1bd82c.png";